var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageRegisterIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 435.385,
    height: 362.32,
    viewBox: "0 0 435.385 362.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22536",
    "data-name": "Group 22536",
    transform: "translate(-1189.615 -1598.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22175",
    "data-name": "Path 22175",
    d: "M217.7,2080.2c-120.23,0-217.7,8.555-217.7,19.1s97.466,19.11,217.7,19.11,217.689-8.557,217.689-19.11-97.46-19.1-217.689-19.1",
    transform: "translate(1189.615 -158.063)",
    fill: "rgba(0,41,107,0.11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22365",
    "data-name": "Group 22365",
    transform: "translate(1235.646 1574.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22378",
    "data-name": "Group 22378",
    transform: "translate(29 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22082",
    "data-name": "Path 22082",
    d: "M504.9,168.439H370.276A23.633,23.633,0,0,0,346.7,192.015V449.522A23.636,23.636,0,0,0,370.276,473.1H504.9a23.632,23.632,0,0,0,23.575-23.577V192.015A23.629,23.629,0,0,0,504.9,168.439",
    transform: "translate(-233.413 -113.401)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22083",
    "data-name": "Path 22083",
    d: "M517.862,187.685H383.234a17.34,17.34,0,0,0-17.289,17.287V462.481a17.344,17.344,0,0,0,17.289,17.289H517.862a17.34,17.34,0,0,0,17.286-17.289V204.972a17.336,17.336,0,0,0-17.286-17.287",
    transform: "translate(-246.37 -126.358)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22084",
    "data-name": "Path 22084",
    d: "M532.473,209.388H397.845a10.228,10.228,0,0,0-10.2,10.2V477.092a10.23,10.23,0,0,0,10.2,10.2H532.473a10.229,10.229,0,0,0,10.2-10.2V219.583a10.226,10.226,0,0,0-10.2-10.2",
    transform: "translate(-260.981 -140.969)",
    fill: "#00296b",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22085",
    "data-name": "Path 22085",
    d: "M344.2,76.056a10.3,10.3,0,0,0-2.314.986,10.538,10.538,0,0,0-2.03,1.529.359.359,0,0,1-.432.052l-2.744-1.583-.014-.008a.684.684,0,0,0-.914.257l-.011.019-1.929,3.341a.693.693,0,0,0-.068.517.677.677,0,0,0,.319.414l.016.012,2.723,1.569a.369.369,0,0,1,.171.4,10.349,10.349,0,0,0-.232,1.246,10.987,10.987,0,0,0,0,2.543,10.459,10.459,0,0,0,.232,1.249.365.365,0,0,1-.193.41l-2.717,1.569a.681.681,0,0,0-.251.931l1.941,3.36a.687.687,0,0,0,.928.251l.021-.012,2.725-1.573a.36.36,0,0,1,.43.052,10.554,10.554,0,0,0,2.03,1.531,10.41,10.41,0,0,0,2.327.988.367.367,0,0,1,.264.35v3.164a.687.687,0,0,0,.681.679h3.881a.683.683,0,0,0,.679-.679V96.458a.364.364,0,0,1,.278-.354,10.38,10.38,0,0,0,2.314-.984,10.563,10.563,0,0,0,2.03-1.531.362.362,0,0,1,.451-.041l2.722,1.573a.688.688,0,0,0,.93-.251l.011-.019,1.929-3.343a.671.671,0,0,0,.066-.515.684.684,0,0,0-.313-.414L357.393,89a.361.361,0,0,1-.173-.4,10.509,10.509,0,0,0,.23-1.247,10.722,10.722,0,0,0,0-2.545,10.359,10.359,0,0,0-.23-1.246.365.365,0,0,1,.193-.412l2.72-1.569a.687.687,0,0,0,.247-.93l-.012-.019-1.927-3.343a.687.687,0,0,0-.931-.249l-2.741,1.583a.364.364,0,0,1-.44-.058,10.405,10.405,0,0,0-4.352-2.512.366.366,0,0,1-.262-.35V72.541a.68.68,0,0,0-.679-.679h-3.881a.684.684,0,0,0-.681.679V75.7a.363.363,0,0,1-.278.354m-1.276,5.851a5.907,5.907,0,1,1-1.727,4.173,5.891,5.891,0,0,1,1.727-4.173",
    transform: "translate(-224.673 -48.381)",
    fill: "rgba(0,41,107,0.15)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22086",
    "data-name": "Path 22086",
    d: "M228.256,124.126a7.582,7.582,0,1,1,7.583-7.581,7.582,7.582,0,0,1-7.583,7.581m21.516-3.549v-7.889h-4.91a16.975,16.975,0,0,0-2.038-5.007l3.5-3.5L240.744,98.6l-3.471,3.471a17,17,0,0,0-4.984-2.1v-4.95H224.4v4.91a16.906,16.906,0,0,0-5.007,2.04l-3.5-3.5-5.577,5.578,3.471,3.471a16.914,16.914,0,0,0-2.1,4.984H206.74V120.4h4.91a16.931,16.931,0,0,0,2.04,5.007l-3.5,3.5,5.577,5.579,3.473-3.471a16.934,16.934,0,0,0,4.982,2.1v4.951h7.889v-4.91a16.943,16.943,0,0,0,5.009-2.04l3.5,3.5,5.577-5.579-3.469-3.471a16.966,16.966,0,0,0,2.094-4.982Z",
    transform: "translate(-139.186 -63.978)",
    fill: "rgba(0,41,107,0.15)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22087",
    "data-name": "Path 22087",
    d: "M178.486,310.021c2.11-5.186,3.273-11.274,5.4-13.374,15.115-2.9,15.529,5.283,21.637,7.745a13.687,13.687,0,0,1-2.8,6.339q-1.231,13.158-8.54,15.2-2.007,1.566-6.018,1.289c.086,1.151.243,2.258.414,3.339-2.027,9.619-11.7,11.123-17.4.962-.189-.338-.366-.675-.538-1.021.011-.078.025-.171.042-.249l0-.008q1-5.682,1.542-9.934.349-2.754.509-4.9-6.02-8.5-1.021-12.462,6.047-1.829,5.412,8.566c1.19-.266.354-.012,1.357-1.492",
    transform: "translate(-114.081 -199.302)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22088",
    "data-name": "Path 22088",
    d: "M197.568,267.7c-6.105-2.462-6.52-10.648-21.636-7.747-2.126,2.1-3.288,8.19-5.4,13.376-1.005,1.48-.167,1.225-1.357,1.492q.636-10.392-5.412-8.568-5,3.967,1.021,12.464-.16,2.152-.509,4.9c-11.535-14.332-6.327-30.663,2.642-34.949a14.011,14.011,0,0,0-6.407,1.4q5.341-5.3,12.6-2.353-.183-4.335,1.245-6.189a13.551,13.551,0,0,0,.476,4.577c3.666-2.464,9.958-2.222,15.939,1.11,7.741,4.313,15.089,13.122,18.654,11.356-1.645,7.669-6.744,11.708-11.858,9.126",
    transform: "translate(-106.128 -162.608)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22089",
    "data-name": "Path 22089",
    d: "M67.438,428.1q-2.033,3.237-4.412,6.631-2.686,3.824-5.816,7.844c-2.128-5.077-8.8-10.125-14.638-8.513,7.085-14.594,13.936-24.612,18.78-28.824q7.851-3.856,23.915-4.49c-.013.086-.029.171-.044.257,5.612,11.27,15.849,9.987,17.94.058,7.119.731,15.455,3.4,19.992,6.411,4.467,4.387,12.3,14.586,20.2,29.407-1.75,1.587-10.425,5.437-14.049,6.071-2.653-3.391-4.449-6.057-6.682-9.452-.262,16.2-.26,27.908.148,35.946.272,5.345.727,11.912,1.4,14.249-10.936,15.071-45.461,15.453-61.119,3.6A386.212,386.212,0,0,0,67.438,428.1",
    transform: "translate(-28.661 -269.8)",
    fill: "#1d3354",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22090",
    "data-name": "Path 22090",
    d: "M52.692,492.984c7.035-1.468,12.176-2.168,21.31-5.371.509-2.911,5.647-8.964,8-12.248,4.661.669-.12,6.489.107,7.628a11.477,11.477,0,0,0,6.285-2.631c4.9-1.814,6.678,7.8,2.4,11.6-2.444,2.174-9.1,4.329-12.392,4.3-11.467,5.4-18.275,8.447-26.731,11.271q-1.563.522-3.057.984-21.056,6.522-28.514,1.4C19.011,502.5,25.1,489.1,27.359,484.3c8.068-2.139,13.285,5.4,14.587,8.311a13.872,13.872,0,0,1-2.228,3.476c2.617-.846,5.656-1.553,9.06-2.279,1.256-.268,2.56-.538,3.914-.82",
    transform: "translate(-13.448 -320.037)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22091",
    "data-name": "Path 22091",
    d: "M266.335,474.588c-1.952-1.581-10.79-7.4-13.275-9.8.383-2.9-2.075-10.369-3.065-14.268-3.9-1.022-1.666,6.1-2.159,7.086a11.133,11.133,0,0,1-4.3-4.68c-3.42-3.424-7.453,4.928-5.072,9.993,1.36,2.893,6.094,7.259,8.729,8.39,1.991,2.355,6.3,8.754,7.951,10.668,11.64,19,28.419,23.338,29.2,13.007-.352-5.233-5.684-15.929-10.713-23.869a47.933,47.933,0,0,1-5.411,2.693,21,21,0,0,1,7.681,8.686c-2.825-3.765-4.921-5.044-9.559-7.906",
    transform: "translate(-160.06 -303.243)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22092",
    "data-name": "Path 22092",
    d: "M61.21,526.6q1.4-2.109,2.51-4.138a10.671,10.671,0,0,1,.7,1.563,14.122,14.122,0,0,1-2.357,3.623c-3.943,1.295-6.911,2.924-8.7,5.452q1.333-4.372,7.844-6.5m82.871-4.6a21,21,0,0,1,7.681,8.686c-2.825-3.765-4.921-5.044-9.559-7.906.626-.249,1.256-.513,1.879-.78",
    transform: "translate(-35.928 -351.431)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22093",
    "data-name": "Path 22093",
    d: "M101.924,499.882a77.147,77.147,0,0,0-.9-9.154q2.24-3.205,4.163-6.275.073,7.324-.2,14.788-1.575.327-3.061.642m-3.282,42.273q2.389-15.517,3.1-27.569c.791-.245,1.6-.505,2.419-.774-.75,9.793-1.89,19.747-3.358,29.835-.7-.483-1.422-.98-2.157-1.492",
    transform: "translate(-66.41 -326.154)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22094",
    "data-name": "Path 22094",
    d: "M228.1,446.53c-3.42-3.424-7.453,4.928-5.072,9.993.074.159.16.323.253.49a25,25,0,0,0,7.01,7.088c.274.179.538.34.791.48l-.3,5.167a2.052,2.052,0,0,1-2.023,1.907l-11.556-.016-.774,0a18.005,18.005,0,0,0,5.545-2.86c3.36-2.991,2.979-9.569.286-11.37a2.856,2.856,0,0,0-2.689-.235,11.932,11.932,0,0,1-2.1,1.4,11.632,11.632,0,0,1-2.658.951l.243-4.247a3.374,3.374,0,0,0,.1-1.688l.056-.967.564-9.793a2.053,2.053,0,0,1,2.022-1.91l12.729.02a1.794,1.794,0,0,1,1.8,1.913l-.463,8.008a10.988,10.988,0,0,1-3.774-4.331",
    transform: "translate(-144.627 -296.847)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22095",
    "data-name": "Path 22095",
    d: "M131.671,803.71c-1.725-41.615-5.2-84.933-10.209-124.686-2.785,25.263-8.681,66.09-17.462,124.311q-4.019,2.289-12.464.7a550.33,550.33,0,0,1,.539-140.7l1.079.744c14.267,10.8,44.181,11.441,57.664.084q6.405,64.405-7.813,139.658-3.838,1.47-11.335-.109",
    transform: "translate(-58.766 -446.584)",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22096",
    "data-name": "Path 22096",
    d: "M94.545,1109.7c-5.192.117-6.294,1.3-10.576,2.488-6.112,1.691-10.121.369-8.776-2.641q6.478-4.064,9.258-7.438c1.648-.868,5.211-.471,5.758,2.475,2.265.317,3.015-.265,3.472-1.738a18.041,18.041,0,0,1,.863,6.854m28.137.7c6.693.121,7.611,1.243,11.134,1.943,8.692,2.463,14.493,1.19,12.684-2.1q-7.972-4.066-11.393-7.439-3.045-1.3-6.339,2.475-4.179.476-5.021-1.739a14.929,14.929,0,0,0-1.065,6.856",
    transform: "translate(-50.448 -741.717)",
    fill: "#240046",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22097",
    "data-name": "Path 22097",
    d: "M154.316,1093.909a9.617,9.617,0,0,0,.412,3.239q-2.567-.368-5.3,2.769-3.815.434-4.85-1.372a24.529,24.529,0,0,0,.751-4.808,21.942,21.942,0,0,0,8.989.171m-40.006.027q-.058,1.89.029,3.547c-.457,1.474-1.207,2.055-3.473,1.739-.5-2.67-3.469-3.245-5.25-2.684a20.645,20.645,0,0,0,.07-2.435,21.206,21.206,0,0,0,8.624-.167",
    transform: "translate(-71.105 -736.352)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22098",
    "data-name": "Path 22098",
    d: "M201.3,375.145q2.278,3.655,8.313,5.342c.086,1.151.243,2.258.414,3.339q-7.03-2.391-8.727-8.68",
    transform: "translate(-135.521 -252.564)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22099",
    "data-name": "Path 22099",
    d: "M110.316,566.523q31.431,3.223,56.2-.344-.032-2.794-.033-5.94-26.114,2.149-45.073.507c-3.522,1.462-6.847,2.716-10.477,3.928l-.48.161,0,.053,0-.058-2.419.78c-.014.222-.027.444-.041.667q1.17.128,2.326.247",
    transform: "translate(-72.704 -377.177)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22100",
    "data-name": "Path 22100",
    d: "M133.89,526.52a171.016,171.016,0,0,0,31.723-1.8c-1.433-1.96-3.181-4.449-4.571-6.3-.719.057-1.447.111-2.178.161l-.169,2.919a2.052,2.052,0,0,1-2.022,1.907l-11.556-.016-.774,0c-.2.07-.393.136-.591.2a21.755,21.755,0,0,1-6.255,1.236q-1.881.884-3.605,1.69m-22.669-8.462q-1.726-.126-3.48-.262.134,1.429.227,2.952c.039.605.066,1.134.082,1.583l3.061-.64.669-.14c4.49-.935,8.208-1.562,12.684-2.722q-6.414-.277-13.242-.77",
    transform: "translate(-72.536 -348.602)",
    fill: "#004b23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22101",
    "data-name": "Path 22101",
    d: "M503.892,295.219a58.711,58.711,0,1,1-58.711,58.713,58.716,58.716,0,0,1,58.711-58.713",
    transform: "translate(-299.715 -198.755)",
    fill: "#aab9de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22102",
    "data-name": "Path 22102",
    d: "M513.971,310.191a53.819,53.819,0,1,0,53.82,53.818,53.82,53.82,0,0,0-53.82-53.818",
    transform: "translate(-309.795 -208.834)",
    fill: "#e9eff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22103",
    "data-name": "Path 22103",
    d: "M590.18,460.059s.39,12.113,1.94,17.534l12.266,8.556-46.167,6.911,11.01-15.212s3.325-16.233,1.583-22.237,19.368,4.449,19.368,4.449",
    transform: "translate(-375.817 -305.484)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22104",
    "data-name": "Path 22104",
    d: "M617.154,478.191s-3.652,8.789-10.526,8.595-8.441-7.968-8.441-7.968Z",
    transform: "translate(-402.726 -321.939)",
    fill: "#bcc9e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22105",
    "data-name": "Path 22105",
    d: "M602.991,384.363s2.221-11.086,3.77-14.44,2.841-18.339-14.333-19.108c0,0-6.586.77-10.2-1.42,0,0,0,2.19.9,2.967a11.4,11.4,0,0,0-10.588,3.742c-4.649,5.166,3.1,23.242,2.708,27.507Z",
    transform: "translate(-384.458 -235.228)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22106",
    "data-name": "Path 22106",
    d: "M587.77,392.463h19.007c2.553,0,4.646,2.452,4.646,5.456v12.812c0,8.22-9.171,14.854-14.153,14.944-5.713.1-14.152-7.047-14.152-15.665V397.919c0-3,2.092-5.456,4.651-5.456",
    transform: "translate(-392.581 -264.223)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22107",
    "data-name": "Path 22107",
    d: "M612.224,398.769s-.026-7.7-6.125-8.888-19.759,3.757-21.7-1.859,26.4-5.524,27.82-1.941,0,12.688,0,12.688",
    transform: "translate(-393.382 -258.233)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22108",
    "data-name": "Path 22108",
    d: "M508.968,529.843v.025a121.922,121.922,0,0,1,15.694-2.891c4.286,5.69,7.36,7,11.277,8.556,6.3-.869,11.615-8.632,11.615-8.811a70.271,70.271,0,0,1,13.382,2.549c.213.027,6.862.91,17.827,12.435a53.822,53.822,0,0,1-86.741-.1c10.692-11.245,16.946-11.765,16.946-11.765",
    transform: "translate(-331.251 -354.612)",
    fill: "#bcc9e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22109",
    "data-name": "Path 22109",
    d: "M637.4,517.694a4.894,4.894,0,0,1,2.627,3.177s-8.221,8.458-13.6,8.583Z",
    transform: "translate(-421.736 -348.534)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22110",
    "data-name": "Path 22110",
    d: "M600.112,528.576,589.5,516.39a4.966,4.966,0,0,0-2.157,3.809s8.206,8.7,12.77,8.377",
    transform: "translate(-395.424 -347.657)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22111",
    "data-name": "Path 22111",
    d: "M620.224,550.83s1.523,13.129,3.014,28.7a54.169,54.169,0,0,1-5.439.272c-1.151,0-2.291-.041-3.426-.111,1.284-15.6,2.405-28.915,2.405-28.915Z",
    transform: "translate(-413.623 -370.806)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22112",
    "data-name": "Path 22112",
    d: "M621.023,539.865a50.9,50.9,0,0,0-7.874-.192.83.83,0,0,0-.634,1.229c.838,1.507,2.539,4.111,4.323,4.111,2.507,0,6.405-4.974,4.185-5.147",
    transform: "translate(-412.302 -363.266)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22113",
    "data-name": "Path 22113",
    d: "M459.538,706.321H555a9.364,9.364,0,0,1,9.338,9.337v0A9.365,9.365,0,0,1,555,725H459.538a9.365,9.365,0,0,1-9.339-9.337v0a9.364,9.364,0,0,1,9.339-9.337",
    transform: "translate(-303.094 -475.526)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22114",
    "data-name": "Path 22114",
    d: "M459.538,803.905H555a9.364,9.364,0,0,1,9.338,9.337v0A9.365,9.365,0,0,1,555,822.582H459.538a9.365,9.365,0,0,1-9.339-9.337v0a9.364,9.364,0,0,1,9.339-9.337",
    transform: "translate(-303.094 -541.224)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2913",
    "data-name": "Rectangle 2913",
    width: 94.429,
    height: 4.255,
    transform: "translate(156.964 238.263)",
    fill: "#004b23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22115",
    "data-name": "Path 22115",
    d: "M483.061,824.262a2.685,2.685,0,1,1-2.685,2.685,2.684,2.684,0,0,1,2.685-2.685m63,0a2.685,2.685,0,1,1-2.685,2.685,2.684,2.684,0,0,1,2.685-2.685m-10.5,0a2.685,2.685,0,1,1-2.687,2.685,2.686,2.686,0,0,1,2.688-2.685m-10.5,0a2.685,2.685,0,1,1-2.685,2.685,2.685,2.685,0,0,1,2.685-2.685m-10.5,0a2.685,2.685,0,1,1-2.685,2.685,2.686,2.686,0,0,1,2.685-2.685m-10.5,0a2.685,2.685,0,1,1-2.685,2.685,2.685,2.685,0,0,1,2.685-2.685m-10.5,0a2.685,2.685,0,1,1-2.685,2.685,2.686,2.686,0,0,1,2.685-2.685",
    transform: "translate(-323.41 -554.929)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22116",
    "data-name": "Path 22116",
    d: "M583.285,896.816h14.734a9.235,9.235,0,0,1,0,18.471H583.285a9.235,9.235,0,1,1,0-18.471",
    transform: "translate(-386.475 -603.776)",
    fill: "#004b23",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageRegisterIconImage);
export default __webpack_public_path__ + "static/media/home-page_register-icon-image.4eca95c6aec10bc25054dd91a0c6aa1f.svg";
export { ForwardRef as ReactComponent };